/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PPermission { 
    id?: string;
    name?: string;
    description?: string;
    groupName?: string;
    short_order?: number;
    dependency_permission?: Array<string>;
    integrity?: string;
}